import { useNavigate } from 'react-router-dom';
import { NavDropdown, Nav, Modal, Form, Button, Alert } from 'react-bootstrap';
import { Navbar } from 'react-bootstrap';
import { useContext } from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { APP_STRUCTURE } from './PermissionConfig'; // Import config
import { clearSession } from './AutoLogoutWrapper';

function NavigationBar() {
  const navigate = useNavigate();
  // const title = 'MIAH & SONS INDUSTRIES LTD.';
  const [companyTitle, setCompanyTitle] = useState(localStorage.getItem('company'));
  const [userRole, setUserRole] = useState('');
  const [restrictedPages, setRestrictedPages] = useState([]);
  const [accountsAccess, setAccountsAccess] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSaving, setPasswordSaving] = useState(false);
  
  useEffect(() => {
    const storedCompany = localStorage.getItem('company');
    if (storedCompany) {
      setCompanyTitle(storedCompany);
    }
  }, []);

  const handleLogOut = async () => {
    try {
      await axios.post(`${window.backendUrl}/logout`, {}, { withCredentials: true });
      clearSession(); // keeps the AI Office preferences
      navigate('/'); // Redirect to login or home page after logout
    } catch (error) {
      console.log('Error logging out:', error);
    }
  };

  const handleChangeCompany = () => {
    const currentCompany = localStorage.getItem('company');
    const newCompany = currentCompany === 'MIAH & SONS INDUSTRIES LTD.' ? 'Tanvir Printing & Packaging IND.' : 'MIAH & SONS INDUSTRIES LTD.';
    localStorage.setItem('company', newCompany);
    setCompanyTitle(newCompany); // Update state after setting localStorage
  };
  
  
  
  const handleNavigation = (path) => {
    navigate(path);
  };

  const openPasswordModal = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setPasswordError('');
    setShowPasswordModal(true);
  };

  const handleChangePassword = async () => {
    setPasswordError('');
    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError('All fields are required.');
      return;
    }
    if (newPassword.length < 6) {
      setPasswordError('New password must be at least 6 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError('New password and confirmation do not match.');
      return;
    }
    setPasswordSaving(true);
    try {
      await axios.post(`${window.backendUrl}/change-password`, { currentPassword, newPassword }, { withCredentials: true });
      setShowPasswordModal(false);
      alert('Password updated successfully.');
    } catch (error) {
      setPasswordError(error.response?.data?.error || 'Failed to update password.');
    } finally {
      setPasswordSaving(false);
    }
  };

  useEffect(() => {
    // Function to handle localStorage changes
    const handleStorageChange = (e) => {
      if (e.key === 'company') {
        setCompanyTitle(e.newValue || '');
      }
    };

    // Function to handle custom storage events (for same-tab changes)
    const handleCustomStorageChange = () => {
      const storedCompany = localStorage.getItem('company');
      setCompanyTitle(storedCompany || '');
    };

    // Listen for storage events (cross-tab changes)
    window.addEventListener('storage', handleStorageChange);
    
    // Listen for custom storage events (same-tab changes)
    window.addEventListener('localStorageChange', handleCustomStorageChange);

    // Initial load
    const storedCompany = localStorage.getItem('company');
    if (storedCompany) {
      setCompanyTitle(storedCompany);
    }

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageChange', handleCustomStorageChange);
    };
  }, []);

  useEffect(() => {
    // We need to fetch who the user is to render the navbar correctly
    // Ideally this comes from a Context, but we can fetch it here or read from localStorage if you saved it there during login (insecure but fast) 
    // or better: fetch verify-token once.
    const fetchUserdata = async () => {
        try {
            const res = await axios.get(`${window.backendUrl}/verify-token`, { withCredentials: true });
            setUserRole(res.data.role);
            let restricted = res.data.restrictedPages;
            if(typeof restricted === 'string') restricted = JSON.parse(restricted);
            setRestrictedPages(restricted || []);
            setAccountsAccess(!!res.data.accountsAccess);
        } catch(e) { console.log(e); }
    }
    fetchUserdata();
  }, []);

  // Helper to check if link should be shown (allowed by default, unless restricted)
  const canAccess = (path) => {
      if (userRole === 'admin') return true;
      return !restrictedPages.includes(path);
  };

  // Helper to check if a dropdown (Category) has ANY visible children
  const canShowCategory = (items) => {
      if (userRole === 'admin') return true;
      return items.some(i => !restrictedPages.includes(i.path));
  };

  return (
    <Navbar expand="lg" style={{backgroundColor:'rgba(135, 206, 235, 0.4)'}}>
      <Navbar.Brand style={{marginLeft:'20px'}}>
        <h3 style={{ color: 'rgba(0, 0, 0, 0.5)',fontFamily:'Apple-System',fontWeight:'900' }}>
          {companyTitle}
        </h3>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto" style={{fontSize:'15px'}}>
            
            {/* DYNAMIC RENDER FROM CONFIG */}
            {APP_STRUCTURE.map((cat, idx) => (
                canShowCategory(cat.items) && (
                    <NavDropdown title={cat.category} id={`${cat.category}-dropdown`} key={idx}>
                        {cat.items.map((item, i) => (
                            // ADD CHECK: !item.hidden
                            !item.hidden && canAccess(item.path) && (
                                <NavDropdown.Item key={i} onClick={() => handleNavigation(item.path)} style={item.red ? { color: 'red', fontWeight: 'bold' } : undefined}>
                                    {item.label}
                                </NavDropdown.Item>
                            )
                        ))}
                    </NavDropdown>
                )
            ))}

            {/* ADMIN ONLY */}
            {userRole === 'admin' && (
              <NavDropdown title="Admin Center" id="admin-center-dropdown">
                <NavDropdown.Item onClick={() => handleNavigation('/manage-users')}>Manage Users</NavDropdown.Item>
                <NavDropdown.Item onClick={() => handleNavigation('/mcp-access')}>MCP Access</NavDropdown.Item>
                <NavDropdown.Item onClick={() => handleNavigation('/alert-rules')}>Alert Rules</NavDropdown.Item>
              </NavDropdown>
            )}
            <Nav.Link onClick={() => handleNavigation('/flowtech-ai')} style={{ textDecoration: 'none', fontWeight: 700, color: '#2f80ed' }}>
              Flowtech AI
            </Nav.Link>
            <Nav.Link onClick={() => window.open('/ai-office', 'ai-office', 'width=1440,height=900')} style={{ textDecoration: 'none' }}>
              AI Office
            </Nav.Link>
            {/* Flowly, the Tally replacement: Finance & Accounts, Board of Directors and admins (the backend decides) */}
            {accountsAccess && (
              <Nav.Link onClick={() => window.open('/accounts/', 'flowly-accounts', 'width=1440,height=900')} style={{ textDecoration: 'none' }}>
                Accounts
              </Nav.Link>
            )}

            <Nav.Link onClick={openPasswordModal}>Change Password</Nav.Link>

            <Nav.Link onClick={handleLogOut}>Log Out</Nav.Link>
        </Nav>
      </Navbar.Collapse>

      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {passwordError && <Alert variant="danger">{passwordError}</Alert>}
          <Form.Group className="mb-3">
            <Form.Label>Current Password</Form.Label>
            <Form.Control type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleChangePassword} disabled={passwordSaving}>
            {passwordSaving ? 'Saving...' : 'Save Password'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Navbar>
  );
}

export default NavigationBar;

